import { selectCar } from "./selectCar";

export const selectCarBrandName = state => {
  const car = selectCar(state);
  return car && car.brand ? car.brand.name : null;
}
